var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": "0.98rem", background: "#fff" } },
    [
      _c("topbar", { attrs: { text: "电子书" } }),
      _vm._v(" "),
      _c(
        "v-touch",
        {
          staticClass: "wrapper",
          on: { swipeleft: _vm.swiperleft, swiperight: _vm.swiperright }
        },
        [
          !_vm.end
            ? _c("div", { staticClass: "main" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.catalogName))
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "content",
                  domProps: { innerHTML: _vm._s(_vm.list[_vm.index].content) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "bottom" }, [
                  _vm._v(_vm._s(_vm.index + 1) + "/" + _vm._s(_vm.totalPage))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.end
            ? _c("div", { staticClass: "endBox" }, [
                _c("img", {
                  staticClass: "endImg",
                  attrs: { src: require("assets/end.png"), alt: "" }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "endBtn", on: { click: _vm.back } }, [
                  _vm._v("返回电子书章节列表")
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33418538", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33418538","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/eBookWord.vue
// module id = null
// module chunks = 